<template>
  <e-btn v-if="operation && isOperationVisible(props.operation)" :disabled="isDisabled">
    <template v-for="(_, scopedSlotName) in $slots" v-slot:[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
  </e-btn>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { EBtn } from '@/core/components/ui';
import { isOperationDisabled, isOperationVisible } from '@/core/utils/permissions';
import { OperationStatus } from '@/graphql/generated';

const props = defineProps<{
  operation?: OperationStatus | null | undefined;
  disabled?: boolean;
}>();

const isDisabled = toRef(() => props.disabled || isOperationDisabled(props.operation));
</script>
